import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';


// Solo el 401 es "tu sesión no vale más" (token vencido/inválido) y amerita
// desloguear. El 403 es "no tenés permiso para ESTO": se avisa y se sigue —
// desloguear por un 403 echaba al usuario de la app por tocar un botón de
// una sección sin permiso.
const unauthorizedCode = [401]

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 20000
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken
	}

	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use((response) => {

	return response.data
}, (error) => {

	// Opt-in por request: lookups donde el "error" es un resultado esperado
	// (ej. buscar por referencia y que no exista devuelve 404) lo manejan
	// ellos mismos con .catch — sin toast global. Uso: fetch({ ..., silentError: true })
	if (error?.config?.silentError) {
		return Promise.reject(error)
	}

	let notificationParam = {
		message: ''
	}

	// Error SIN respuesta (red caída, timeout, request abortado, CORS): no
	// dereferenciar error.response — lo hacía sin guard y tiraba TypeError, que
	// pisaba el error original y rompía el manejo de errores de los flujos
	// nuevos de blob/upload largos. Reportamos genérico y propagamos el original.
	if (!error.response) {
		notificationParam.message = 'Error de red o tiempo de espera agotado'
		notification.error(notificationParam)
		return Promise.reject(error)
	}

	const status = error.response.status
	const respData = error.response.data

	// Remove token and redirect
	if (unauthorizedCode.includes(status)) {
		notificationParam.message = respData?.message
		notificationParam.description = 'Please login again'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	if (status === 403) {
		notificationParam.message = 'Sin permiso'
		notificationParam.description = respData?.message || 'No tenés permiso para acceder a esta sección.'
		// Si el 403 vino de los fetch iniciales de una pantalla recién abierta,
		// el listener del router vuelve a la vista anterior (ver routes/index.js).
		window.dispatchEvent(new CustomEvent('api-permission-denied'))
	}

	if (status === 400 || status === 409) {
		notificationParam.message = respData?.message
	}

	if (status === 404) {
		notificationParam.message = respData?.message
	}

	if (status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service